import { render, staticRenderFns } from "./BeaconDealEditor.vue?vue&type=template&id=aada565e&"
import script from "./BeaconDealEditor.vue?vue&type=script&lang=ts&"
export * from "./BeaconDealEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports